export default {
  pt: {
    title: "Sem problemas!",
    description:
      "Vamos te colocar em contato com o seu consultor, que vai te ajudar a identificar o modelo certo da sua bike e confirmar os detalhes do seu seguro.",
    talkToConsultantButton: "Falar com consultor",
    cancelButton: "Cancelar",
    closeButton: "Fechar",
  },

  en: {
    title: "No worries!",
    description:
      "We'll put you in touch with your consultant, who will help you identify the right model for your bike and confirm your insurance details.",
    talkToConsultantButton: "Talk to consultant",
    cancelButton: "Cancel",
    closeButton: "Close",
  },
};
